import React, { useState, useEffect } from "react";
import history from "../../history";

import { Row, Col, Card, CardBody } from "reactstrap";
import CartTitle from "../CartTitle";
import { Tabs, Tab } from "react-bootstrap";

import Information from "../Informatin";
import Branch from "../Branch";

import { fetchQueryParams } from "../../utils/comman";
import Loader from "../Loader";

import get from "lodash/get";

const _ = { get };

function DetailPage(props) {
  let { elements } = props;
  const [key, setKey] = useState("detail");

  useEffect(() => {
    if (props.selectedId) {
      props.handleSingleDealerFetch(props.selectedId);
    }
  }, [props.selectedId]);

  const handleSelectTab = (tab) => {
    setKey(tab);
    if (tab === "detail") {
      props.handleSingleDealerFetch(props.selectedId);
    } else {
      props.handleDealerBranchFetch(props.selectedId);
    }
  };

  const handleToCreateForm = () => {
    if (props.selectedId) {
      history.push(
        `/dealer/create-branch?dealerId=${props.selectedId}&tab=${key}`
      );
    } else {
      history.push(`/dealer/list`);
    }
  };
  return (
    <React.Fragment>
      {props.dealerDataStatus !== false ? <Loader /> : null}
      {props.dealerBranchDataStatus !== false ? <Loader /> : null}
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={
                props.dealerData !== null
                  ? props.dealerData.dealerName.toUpperCase()
                  : "Dealer Name"
              }
              Name={"Search"}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
        </Row>
        <Card className="mb-3">
          <CardBody className="px-0 px-lg-1 py-0 py-lg-1">
            <Row className="custom-tab">
              <Col sm={12}>
                <Tabs
                  id="tab-id"
                  activeKey={key}
                  onSelect={(k) => handleSelectTab(k)}
                >
                  <Tab
                    eventKey="detail"
                    title={_.get(
                      elements,
                      "dealerDetailElements.tabDetailElement",
                      "Details"
                    )}
                  >
                    <Information
                      query={props.query}
                      dealerData={props.dealerData}
                      handleSingleDealerFetch={props.handleSingleDealerFetch}
                      elements={props.elements}
                      selectedId={props.selectedId}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  <Tab
                    eventKey="branch"
                    title={_.get(
                      elements,
                      "dealerDetailElements.tabBranchElement",
                      "Branch"
                    )}
                  >
                    <Branch
                      dealerBranchData={props.dealerBranchData}
                      handleToCreateForm={() => handleToCreateForm()}
                      elements={props.elements}
                      selectedId={props.selectedId}
                      count={props.count}
                      page={props.page}
                      countryCode={props.countryCode}
                      country={props.country}
                      state={props.state}
                      city={props.city}
                      dealerEmail={props.dealerEmail}
                      dealerPhone={props.dealerPhone}
                      dealerId={props.dealerId}
                    />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
}
export default DetailPage;
